var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('div',[_c('Stars',{staticClass:"width-full",attrs:{"star-class":_vm.starClass,"rating":_vm.data.average_score}}),_vm._v(" "),(_vm.showCount)?_c('span',[_vm._v("\n        "+_vm._s(_vm.data.count)+" \n        "+_vm._s(_vm.$translate('user_reviews', 'recensioner'))+"\n    ")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }